import React, { useCallback, useEffect, useState } from 'react'

import { Box } from '@material-ui/core'

import { LoadingFeedback } from 'components'
import CourseHeader from './components/CourseHeader'
import ModuleList from './components/ModuleList'

import useAuthTraining from 'hooks/useAuthTraining'
import useSnackbar from 'hooks/useSnackbar'
import helpers from 'helpers'
import * as service from 'service'
import { routes } from 'TrainingRoutes'
import useStyles from './styles'

const CourseDetail = ({ match, history }) => {
  const classes = useStyles()
  const snackbar = useSnackbar()
  const { portalToken: contextPortalToken } = useAuthTraining()

  const portalToken = match?.params?.portalToken || contextPortalToken
  const courseId = match?.params?.courseId

  const [course, setCourse] = useState(null)
  const [modules, setModules] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const loadData = useCallback(async () => {
    setIsLoading(true)
    try {
      const [courseResponse, modulesResponse] = await Promise.all([
        service.trainingPortal.courses.show(courseId),
        service.trainingPortal.courses.modules(courseId),
      ])
      setCourse(courseResponse?.data?.course || null)
      setModules(modulesResponse?.data?.modules || [])
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao carregar o curso.',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }, [courseId, snackbar])

  useEffect(() => {
    loadData()
    // eslint-disable-next-line
  }, [courseId])

  const handleBack = () => {
    history.push(`/training/${portalToken}/home`)
  }

  const handleStart = () => {
    const allLessons = modules?.flatMap((module) => module?.lessons ?? []) ?? []
    const targetLesson =
      allLessons.find((lesson) => !lesson?.completed) ?? allLessons[0]
    if (!targetLesson?.id) return
    const isExercise = targetLesson?.kind === 'exercise'
    const route = isExercise ? routes.exerciseContent : routes.lessonContent
    const url = route
      .replace(':portalToken', portalToken)
      .replace(':courseId', courseId)
      .replace(':lessonId', targetLesson.id)
    history.push(url)
  }

  const handleCertificate = () => {
    history.push(
      routes.courseCertificate
        .replace(':portalToken', portalToken)
        .replace(':courseId', courseId),
    )
  }

  return (
    <Box className={classes.root}>
      <LoadingFeedback open={isLoading} />
      {!isLoading && (
        <>
          <CourseHeader
            course={course}
            modules={modules}
            onBack={handleBack}
            onStart={handleStart}
            onCertificate={handleCertificate}
          />
          <Box className={classes.body}>
            <ModuleList
              modules={modules}
              portalToken={portalToken}
              courseId={courseId}
              history={history}
            />
          </Box>
        </>
      )}
    </Box>
  )
}

export default CourseDetail
